import React, { Component } from 'react';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import { ValidatorComponent } from '../services/validators';

export default class TimeRangeQuestion extends Component {
    state = {
        isItHappening: 'yes'
    }

    constructor() {
        super();
        this.handleIsItHappeningChange = ({ target }) => {
            this.setState({ isItHappening: target.value })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isItHappening !== this.state.isItHappening) {
            if (this.state.isItHappening === 'yes') {
                this.props.onChange({ name: 'endDate', value: null })
                this.props.onChange({ name: 'endTime', value: null })
            } else {
                this.props.onChange({ name: 'endDate', value: new Date() })
                this.props.onChange({ name: 'endTime', value: new Date() })
            }
        }
    }

    render(props) {
        const { startDate, endDate, onChange } = this.props;

        let timeStoppedQuestion = (<div>
            <div className="question-divider"></div>
            <span className="primary-question">
                What time did it stop?</span>
            <label className="question-helper">Select the time when the smell stopped.</label>
            <KeyboardDatePicker
                clearable
                value={endDate}
                placeholder="31/01/2020"
                onChange={date => {
                    onChange({ name: 'endDate', value: date })
                    onChange({ name: 'endTime', value: date })
                }}
                format="dd/MM/yyyy"
                autoOk={true}
                disableFuture={true}
                maxDateMessage="Date should not be later than today's date"
            />
            <KeyboardTimePicker
                clearable
                value={endDate}
                onChange={date => {
                    onChange({ name: 'endTime', value: date })
                    onChange({ name: 'endDate', value: date })
                }}
                placeholder="08:00 AM"
                mask="__:__ _M"
                autoOk={true}
            />
            <ValidatorComponent name='endDate' messages={this.props.validatorMessages}></ValidatorComponent>
        </div>)

        if (this.state.isItHappening === 'yes') {
            timeStoppedQuestion = (<div></div>)
        }
        const isStillHappening = this.state.isItHappening === 'yes';
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div className="question-section" >
                    <span className="primary-question">3. What time did it happen?</span>
                    <label className="question-helper" htmlFor='startTime'>
                        Select the time when the smell started occuring.
                    </label>
                    <KeyboardDatePicker
                        clearable
                        value={startDate}
                        placeholder="31/01/2020"
                        onChange={date => {
                            onChange({ name: 'startDate', value: date })
                            onChange({ name: 'startTime', value: date })
                        }}
                        format="dd/MM/yyyy"
                        autoOk={true}
                        disableFuture={true}
                        maxDateMessage="Date should not be later than today's date"
                    />
                    <KeyboardTimePicker
                        clearable
                        value={startDate}
                        onChange={date => {
                            onChange({ name: 'startTime', value: date })
                            onChange({ name: 'startDate', value: date })
                        }}
                        placeholder="08:00 AM"
                        mask="__:__ _M"
                        autoOk={true}
                    />
                    <ValidatorComponent name='startDate' messages={this.props.validatorMessages}></ValidatorComponent>
                    <div className="question-divider"></div>
                    <span className="primary-question">Is it still happening?</span>
                    <div className="radio-wrapper">
                        <div className={isStillHappening ? 'radio__item-active radio__item' : 'radio__item'}>
                            <input type="radio" onChange={this.handleIsItHappeningChange} value="yes" name="isithappening" id="iityes" checked={isStillHappening} />
                            <label htmlFor="iityes">Yes</label>
                        </div>
                        <div className={!isStillHappening ? 'radio__item-active radio__item' : 'radio__item'}>
                            <input type="radio" onChange={this.handleIsItHappeningChange} value="no" name="isithappening" id="iitno" checked={!isStillHappening} />
                            <label htmlFor="iitno">No</label>
                        </div>
                    </div>
                    {timeStoppedQuestion}
                </div>
            </MuiPickersUtilsProvider>
        )
    }
}